// Small formatting helpers (UTC-aware, tabular-friendly).

export function ago(iso?: string | null, now = Date.now()): string {
  if (!iso) return "never";
  const s = Math.max(0, Math.round((now - new Date(iso).getTime()) / 1000));
  if (s < 5) return "just now";
  if (s < 60) return `${s}s ago`;
  if (s < 3600) return `${Math.floor(s / 60)}m ago`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ${Math.floor((s % 3600) / 60)}m ago`;
  return `${Math.floor(s / 86400)}d ago`;
}

export function duration(fromIso: string, toIso?: string | null, now = Date.now()): string {
  const end = toIso ? new Date(toIso).getTime() : now;
  const s = Math.max(0, Math.round((end - new Date(fromIso).getTime()) / 1000));
  if (s < 60) return `${s}s`;
  const m = Math.floor(s / 60);
  if (m < 60) return `${m}m ${String(s % 60).padStart(2, "0")}s`;
  const h = Math.floor(m / 60);
  if (h < 48) return `${h}h ${String(m % 60).padStart(2, "0")}m`;
  return `${Math.floor(h / 24)}d ${h % 24}h`;
}

export function dateTime(iso?: string | null): string {
  if (!iso) return "—";
  const d = new Date(iso);
  return d.toLocaleString(undefined, { year: "numeric", month: "short", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit" });
}

export function ms(v?: number | null, digits = 1): string {
  if (v === undefined || v === null) return "—";
  return v >= 100 ? `${Math.round(v)} ms` : `${v.toFixed(digits)} ms`;
}

export function pct(v?: number | null): string {
  if (v === undefined || v === null) return "—";
  return `${Number.isInteger(v) ? v : v.toFixed(1)}%`;
}

export function shortId(id: string): string {
  return id.slice(0, 8);
}
